import { IconButton as MuiIconButton } from "@material-tailwind/react/components/IconButton";
import { forwardRef } from "react";
import type { IconButtonProps } from "@material-tailwind/react/components/IconButton";
import { Tooltip } from "@material-tailwind/react";
import SvgIcon from "@/components/common/SvgIcon";
import { Spinner } from "@material-tailwind/react";

type TProps = {
  iconName: string;
  className?: string;
  svgClassName?: string;
  isLoading?: boolean;
  placeholder?: string;
  color: string;
  tooltip?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
};
export type Ref = HTMLButtonElement;

const IconButton = forwardRef<
  Ref,
  Omit<IconButtonProps, "children" | "placeholder"> & TProps
>((props, ref) => {
  const {
    color,
    className,
    isLoading,
    iconName,
    svgClassName,
    tooltip,
    tooltipPlacement = "top",
    disabled,
    ...rest
  } = props;

  const buttonContent = (
    <MuiIconButton
      placeholder=""
      {...rest}
      color={color}
      className={className}
      ref={ref}
      disabled={disabled}
    >
      {!isLoading ? (
        <SvgIcon
          className={svgClassName}
          iconName={iconName}
          fill={`fill-${color}-600`}
        />
      ) : (
        <Spinner className="h-4 w-4" />
      )}
    </MuiIconButton>
  );

  if (disabled && tooltip) {
    return (
      <Tooltip content={tooltip} placement={tooltipPlacement}>
        <span className="inline-block cursor-not-allowed">{buttonContent}</span>
      </Tooltip>
    );
  }

  return buttonContent;
});

export default IconButton;
